export enum NotificationSatuses {
  NEW = 'new',
  ACKNOWLEDGED = 'ack',
}

export enum NotificationKeys {
  REQUESTED = 'requested',
  SENT = 'sent',
  OPEN = 'open',
  EXPIRED = 'expired',
  BAD_MOLLY_TOTAL = 'bad_total:molly',
  CANCELED = 'canceled',
  SUBMITTED = 'submitted',
  BAD_GAMBIT_TOTAL = 'bad_total:gambit',
  LOW_BALANCE = 'balance_low',
  UNACCEPTED = 'unaccepted',
  ACCEPTED = 'accepted',
}

export enum NotificationLevels {
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
}

export interface Notification {
  date: string;
  id: number;
  key: NotificationKeys;
  level: NotificationLevels;
  message: string;
  notifier: string;
  object: string;
  recipient: string;
  status: NotificationSatuses;
  url: string;
}

interface NotificationsStarted {
  type: 'notifications/started';
}

interface NotificationsFinished {
  type: 'notifications/finished';
  notifications?: Notification[];
  error?: string;
}

interface NotificationAcknowledgeStarted {
  type: 'notification/acknowledge/started';
}

interface NotificationAcknowledgeFinished {
  type: 'notification/acknowledge/finished';
  success: boolean;
  error?: string;
}

export type NotificationsActions = NotificationsStarted | NotificationsFinished;
export type NotificationAcknowledgeActions =
  | NotificationAcknowledgeStarted
  | NotificationAcknowledgeFinished;
